import {
	forgotPasswordInvalidPasswordResetKey,
	forgotPasswordTooManyAuthAnswerAttempts,
	forgotPasswordTooManyUsernameGuesses
} from '@constants';

export function forgotPasswordErrorRoute(errorCode: string) {
	let errorRoute = '';
	switch (errorCode) {
		case forgotPasswordTooManyUsernameGuesses:
			errorRoute = 'forgot-password-guess-username-attempts';
			break;
		case forgotPasswordInvalidPasswordResetKey:
			errorRoute = 'forgot-password-invalid-key';
			break;
		case forgotPasswordTooManyAuthAnswerAttempts:
			errorRoute = 'forgot-password-auth-question-attempts';
			break;
		default:
			errorRoute = 'home';
			break;
	}

	return errorRoute;
}
